/**
 * Route for `clevertap-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ClevertapIntegrationPage } from "../features/clevertap-integration/ClevertapIntegrationPage";

export const clevertapIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/clevertap-integration",
	component: ClevertapIntegrationPage,
});

export default clevertapIntegrationRoute;
